import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError } from 'rxjs';
import { errorHandl } from 'src/app/utils/network-utils';
import { urls } from 'src/app/utils/url.utils';

@Injectable({
  providedIn: 'root'
})
export class VarificationService {

  constructor(private http: HttpClient) {

  }

  verifyDriver(id: any, payload: any) {
    
    return this.http.patch(urls.API_URL + `drivers/${id}/manage` , payload)
      .pipe(catchError(errorHandl));
  }

  getNotifications(queryParams?: any){
    const params = new HttpParams({ fromObject: queryParams });
    return this.http.get(urls.API_URL + urls.NOTIFICATION, { params })
      .pipe(catchError(errorHandl));
  }

}
